import { render } from "./ObjectivesListing.vue?vue&type=template&id=1860b1e0"
import script from "./ObjectivesListing.vue?vue&type=script&lang=js"
export * from "./ObjectivesListing.vue?vue&type=script&lang=js"

import "./ObjectivesListing.vue?vue&type=style&index=0&id=1860b1e0&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__